
import mixins from "vue-typed-mixins";
import CPS from "./ColorPageScript";
export default mixins(CPS).extend({
  created() {
      this.setViewportSize(1920, 1500);
  }
});
